/* eslint-disable qwik/valid-lexical-scope */
import type { QRLEventHandlerMulti } from "@builder.io/qwik";
import { component$, useStyles$ } from "@builder.io/qwik";
import { cn } from "../../utils/tailwind-helper";

export const VideoPlayButton = component$<{
    onClick$?: QRLEventHandlerMulti<PointerEvent, HTMLButtonElement>;
    class?: string;
}>(({ onClick$, class: className, ...props }) => {
    useStyles$(`
        @keyframes arrow-in-video {
            0% {
                transform: translateX(0) scale(1);
            }
            50% {
                transform: translateX(19px) scale(0);
            }
            55% {
                transform: translateX(-18px) scale(1);
                opacity: 0;
            }
            60% {
                opacity: 1;
            }
            100% {
                transform: translateX(0) scale(1);
            }
        }
        
        @keyframes arrow-out-video {
            0% {
                transform: translateX(0) scale(1);
            }
            50% {
                transform: translateX(-19px) scale(0);
            }
            55% {
                transform: translateX(18px) scale(1);
                opacity: 0;
            }
            60% {
                opacity: 1;
            }
            100% {
                transform: translateX(0) scale(1);
            }
        }
    `);

    const arrowMouseEnterAnimationClasses = "[&_svg_path]:animate-[arrow-in-video_400ms_cubic-bezier(0.4,0,0.2,1)]";
    const arrowMouseLeaveAnimationClasses = "[&_svg_path]:animate-[arrow-out-video_400ms_cubic-bezier(0.65,0,0.35,1)]";

    return (
        <button
            onClick$={onClick$}
            class={cn(
                "video-play-button absolute left-0 top-0 flex h-full w-full cursor-pointer items-center justify-center border-none outline-none",
                className,
            )}
            aria-label={props["aria-label"]}
            type="button"
        >
            <div
                class={cn(
                    "flex items-center justify-center gap-[16px] silver:gap-[22.55px]",
                    "bg-white/80 backdrop-blur-[24px]",
                    "rounded-full py-[4px] pl-[22px] pr-[4px] silver:py-[8.4545px] silver:pl-[28.1818px] silver:pr-[8.45px]",
                    "text-lg font-normal text-primary-800 silver:text-[25.3636px] silver:leading-[normal]",
                    "transform-gpu antialiased transition-[transform,box-shadow] duration-300 will-change-transform hover:scale-110 hover:shadow-[0px_8px_20px_rgba(255,255,255,0.25)]",
                )}
                style={{ transformStyle: "preserve-3d", backfaceVisibility: "hidden" }}
                onMouseEnter$={(e) => {
                    const target = e.target as HTMLDivElement;
                    target.classList.remove(arrowMouseLeaveAnimationClasses);
                    target.classList.add(arrowMouseEnterAnimationClasses);
                }}
                onMouseLeave$={(e) => {
                    const target = e.target as HTMLDivElement;
                    target.classList.remove(arrowMouseEnterAnimationClasses);
                    target.classList.add(arrowMouseLeaveAnimationClasses);
                }}
            >
                <span class="subpixel-antialiased">{props["aria-label"]}</span>
                <span
                    class={cn(
                        "flex items-center justify-center rounded-full bg-white",
                        "h-[40px] w-[40px] text-primary-800 silver:h-[45px] silver:w-[45px]",
                    )}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="34" viewBox="0 0 35 34" fill="none">
                        <path
                            d="M14.4546 22.6365L20.091 17.0001L14.4546 11.3638"
                            stroke="currentColor"
                            stroke-width="2.11364"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class={cn("origin-center")}
                        />
                    </svg>
                </span>
            </div>
        </button>
    );
});
